import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableDirective } from './table.directive';
import { TableHeadDirective } from './table-head/table-head.directive';
import { TableHeadCellDirective } from './table-head/table-cell/table-cell.directive';
import { TableRowDirective } from './table-row/table-row.directive';
import { TableCellDirective } from './table-row/table-cell/table-cell.directive';

@NgModule({
  declarations: [
    TableDirective,
    TableHeadDirective,
    TableHeadCellDirective,
    TableRowDirective,
    TableCellDirective,
  ],
  imports: [CommonModule],
  exports: [
    TableDirective,
    TableHeadDirective,
    TableHeadCellDirective,
    TableRowDirective,
    TableCellDirective,
  ],
})
export class TableModule {}
